import { render, staticRenderFns } from "./FormArticle.vue?vue&type=template&id=17799c04&scoped=true"
import script from "./FormArticle.vue?vue&type=script&lang=js"
export * from "./FormArticle.vue?vue&type=script&lang=js"
import style0 from "./FormArticle.vue?vue&type=style&index=0&id=17799c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17799c04",
  null
  
)

export default component.exports